// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605250654/js/" + chunkId + "." + {"44":"c057e932","225":"db6be087","481":"3f119911","486":"fbdba689","770":"a6349cf2"}[chunkId] + ".0.5405511446721267.chunk.js";
};